import React from 'react';
import PropTypes from 'prop-types';
import Text, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@gc-npm/components.text';
import { sendTaggingInfo } from './utils';
import { COLORS } from '@gc-npm/utils.enums.colors';

function RadioButton({
  className,
  id,
  name,
  value,
  label,
  error,
  onChange,
  formProps,
  checked: controlledChecked,
  disabled,
}) {
  const isSelected = Boolean(controlledChecked);

  const taggingInfo = {
    componentVariation: 'all',
    componentContent: '',
    componentProduct: '',
    componentName: name,
  };

  const handleOnChange = (event) => {
    const { checked: selected } = event.target;
    sendTaggingInfo(
      { ...taggingInfo, componentContent: `radio-${value}-${selected}` },
      'change'
    );
    onChange(event);
  };

  return (
    <div className={`radio-wrapper ${className}`} data-cy={id}>
      <label htmlFor={id || name} data-cy={`${id}__label`}>
        <input
          {...formProps}
          id={id || name}
          name={name}
          type="radio"
          value={value}
          checked={isSelected}
          onChange={handleOnChange}
          data-cy={`${id}__input`}
          disabled={disabled}
          className={`${error ? 'error' : ''} ${isSelected ? 'selected' : ''}`}
        />
        {label && <div className="labelText">{label}</div>}
      </label>
      {error && (
        <Text
          className="radio-wrapper_error"
          text={error}
          color={TEXT_COLOR.RED}
          kind={TEXT_KIND.SPAN}
          size={TEXT_SIZE.CAPTION3}
          cyData={`${id}__error`}
        />
      )}
      <style jsx>{`
        .radio-wrapper {
          display: block;
          position: relative;
          width: 100%;
          font-size: 16px;
          user-select: none;
        }

        label {
          cursor: pointer;
          display: flex;
          justify-content: flex-end;
        }

        input[type='radio'] {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          width: 20px;
          height: 20px;
          border: 2px solid #ccc;
          border-radius: 50%;
          position: relative;
          margin-right: 12px;
          cursor: pointer;
        }

        input[type='radio'].selected {
          border-color: ${COLORS.movistarBlue};
        }

        input[type='radio']:focus-visible {
          outline: 2px solid ${COLORS.movistarBlue};
          outline-offset: 3px;
        }

        input[type='radio'].selected::after {
           content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            width: 10px;
            height: 10px;
            background: ${COLORS.movistarBlue};
            border-radius: 50%;
            transform: translate(-50%, -50%);
        }

        input[type='radio']:disabled {
          cursor: not-allowed;
        }

        .labelText {
          font-family: inherit;
          font-size: 16px;
          color: #333;
        }

        .radio-wrapper_error {
          margin-top: 4px;
        }
      `}</style>
    </div>
  );
}

RadioButton.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.node,
  error: PropTypes.string,
  onChange: PropTypes.func,
  formProps: PropTypes.object,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
};

RadioButton.defaultProps = {
  className: '',
  label: null,
  error: '',
  onChange: () => {},
  formProps: {},
  checked: false,
  disabled: false,
};

export default RadioButton;
